import { glow } from "@/vessels";

export const birdFlags = { on: false };
const rand = (a, b) => a + Math.random() * (b - a);
const TINTS = ["48,100%,78%", "265,80%,82%", "20,95%,80%", "190,80%,82%", "0,0%,96%"];

export const makeBird = (w, h, x = rand(-w * 0.1, w)) => ({
  x, y: rand(h * 0.1, h * 0.85), size: rand(10, 26) * Math.max(0.6, Math.min(w, h) / 900),
  vx: rand(1.4, 3.2), ph: rand(0, 6.28), flap: rand(7, 11), tint: TINTS[Math.floor(Math.random() * TINTS.length)],
});

export const drawBird = (ctx, b, t, flying) => {
  const a = flying ? Math.sin(t * b.flap + b.ph) * 0.9 : 0.15 + Math.sin(t * 0.8 + b.ph) * 0.05;
  const s = b.size;
  ctx.globalCompositeOperation = "lighter";
  glow(ctx, b.x, b.y, s * 2.6, b.tint, 0.18);
  ctx.strokeStyle = `hsla(${b.tint},0.85)`;
  ctx.lineWidth = Math.max(1.5, s * 0.18);
  ctx.lineCap = "round";
  [-1, 1].forEach((side) => {
    ctx.beginPath();
    ctx.moveTo(b.x, b.y);
    ctx.quadraticCurveTo(b.x + side * s * 0.7, b.y - s * (0.2 + a * 0.9), b.x + side * s * 1.5, b.y - s * a * 0.6);
    ctx.stroke();
  });
  glow(ctx, b.x, b.y, s * 0.5, "0,0%,100%", 0.6);
};

export const birdsong = {
  id: "birdsong",
  name: "Birdsong",
  subtitle: "Soft glowing birds that flutter when bird is on",
  init(w, h) {
    return { birds: Array.from({ length: 16 }, () => makeBird(w, h)) };
  },
  draw(ctx, w, h, t, s, p, k) {
    ctx.globalCompositeOperation = "source-over";
    ctx.fillStyle = "rgba(16,12,38,0.22)";
    ctx.fillRect(0, 0, w, h);
    const flying = birdFlags.on;
    window.__birdsFlying = flying;
    s.birds.forEach((b, i) => {
      b.x += (flying ? b.vx : 0.25) * k;
      b.y += Math.sin(t * (flying ? 2 : 0.6) + b.ph) * (flying ? 0.8 : 0.2) * k;
      if (b.x - b.size * 2 > w) s.birds[i] = makeBird(w, h, -b.size * 2);
      drawBird(ctx, b, t, flying);
    });
  },
};
